import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: '4rem', color: '#173c95', marginBottom: '1rem' }}>404</h1>
        <h2 style={{ fontSize: '2rem', color: '#434343', marginBottom: '1rem' }}>Page Not Found</h2>
        <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '2rem' }}>
          Sorry, the page you're looking for doesn't exist.
        </p>
        <Link 
          to="/" 
          style={{
            display: 'inline-block',
            padding: '10px 30px',
            backgroundColor: '#173c95',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            fontSize: '1rem',
            fontWeight: '600'
          }}
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
